define('v3/Common/Components/Search/SearchBox.Component',[
	'text!v3/Common/Components/Search/SearchBox.Component.html',
	'knockout',
	'env',
	'lodash',
	'v3/Common/Services/pageStateService',
	'v3/Common/Models/enums',
	'v3/Common/Bindings/SvgIcon.Binding'
], function (template, ko, env, _, pageStateService, enums) {
	function searchBox (params) {
		var self = this;
		var hasAutoFocus = params && params.hasAutoFocus;

		self.autoFocus = ko.observable(false);
		self.searchValue = ko.observable(pageStateService.getStringObservable('q')() || '');

		self.trimmedSearchValue = ko.computed(function () {
			return self.searchValue().trim();
		});

		var minQueryLength = 3;

		self.isQueryValid = ko.computed(function () {
			var trimmedSearchValue = self.trimmedSearchValue();

			// Allow these:
			// -- an integer
			// -- a string consisting of only zeroes
			// -- any search string with length >= minQueryLength
			return isInteger(trimmedSearchValue.replace(/^0+/, '')) ||
				/^0+$/.test(trimmedSearchValue) ||
				trimmedSearchValue.length >= minQueryLength;
		});

		if (_.isUndefined(hasAutoFocus) || hasAutoFocus) {
			setTimeout(function () {
				self.autoFocus(true);
			}, 10);
		}
		self.getResults = function () {
			if (self.isQueryValid()) {
				window.location.href = '/V4/' + env.userInfo.classId + '/search?q=' + encodeURIComponent(self.trimmedSearchValue());
			}
		};

		self.getResultsOnEnter = function (vm, event) {
			if (event.keyCode === enums.keyCodes.enter) {
				if (self.isQueryValid()) {
					window.location.href = '/V4/' + env.userInfo.classId + '/search?q=' + encodeURIComponent(self.trimmedSearchValue());
				}
				return false;
			}
			return true;
		};

		function isInteger (str) {
			var n = Math.floor(Number(str));
			return String(n) === str && n >= 0;
		}
	}

	return { viewModel: searchBox, template: template };
});

